module.exports = __webpack_public_path__ + "img/SINGLE DEVICE SX LIME.e94a881.svg";